import React from "react";
import { FaStethoscope } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import styles from "../NewIPDPatientAdmission.module.css";

const SymptomsDiagnosis = ({ formData, handleInputChange }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.section}>
      <h3><FaStethoscope /> {t("Symptoms & Diagnosis")}</h3>
      <div className={styles.grid2}>
        <div>
          <label>{t("Symptoms Type")}</label>
          <input
            name="option2"
            value={formData.option2}
            onChange={handleInputChange}
            placeholder={t("Enter symptoms type")}
          />
        </div>
        <div>
          <label>{t("Symptoms Title")}</label>
          <input name="symptomsTitle" value={formData.symptomsTitle} onChange={handleInputChange} placeholder={t("Enter symptoms title")} />
        </div>
      </div>
      <div className={styles.grid2} style={{ marginTop: "1rem" }}>
        <div>
          <label>{t("Symptoms in Detail")}</label>
          <textarea name="symptomsDesc" value={formData.symptomsDesc} onChange={handleInputChange} rows={3} placeholder={t("Describe symptoms in detail")} />
        </div>
        <div>
          <label>{t("Primary Diagnosis")}</label>
          <textarea name="diagnosis" value={formData.diagnosis} onChange={handleInputChange} rows={3} placeholder={t("Enter primary diagnosis")} />
        </div>
      </div>

      <div className={styles.grid2} style={{ marginTop: "1rem" }}>
        <div>
          <label>{t("Personal History of")}</label>
          <textarea name="pho" value={formData.pho} onChange={handleInputChange} rows={5} placeholder={t("Personal History of...")} />
        </div>
        <div>
          <label>{t("Complaint of")}</label>
          <textarea name="co" value={formData.co} onChange={handleInputChange} rows={5} placeholder={t("Complaint of...")} />
        </div>
      </div>

      <div className={styles.grid2} style={{ marginTop: "1rem" }}>
        <div>
          <label>{t("Known Case of")}</label>
          <textarea name="kco" value={formData.kco} onChange={handleInputChange} rows={1} placeholder={t("Known Case of...")} />
        </div>
        <div>
          <label>{t("Clinical Findings")}</label>
          <textarea name="cf" value={formData.cf} onChange={handleInputChange} rows={2} placeholder={t("Clinical Findings...")} />
        </div>
      </div>
    </div>
  );
};

export default SymptomsDiagnosis;
